import { render, staticRenderFns } from "./bulk-modal.vue?vue&type=template&id=01b37280&"
import script from "./bulk-modal.vue?vue&type=script&lang=js&"
export * from "./bulk-modal.vue?vue&type=script&lang=js&"
import style0 from "./bulk-modal.vue?vue&type=style&index=0&id=01b37280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports